module.exports = __webpack_public_path__ + "static/img/bbbbaaa.37cf7a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bbbbaaa.jpg
// module id = 5Ic8
// module chunks = 73